import { ArrowLeft01Icon, LockIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessControl } from '@/features/access-control';
import {
  Avatar,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';

enum AccessStatus {
  LOADING = 'LOADING',
  GRANTED = 'GRANTED',
  REJECTED = 'REJECTED',
}

type Props = {
  //
};

const withAccessControl = <P extends Props>(
  WrappedComponent: React.ComponentType<P>,
  access: string
) => {
  const EnhancedComponent = (props: P & Props) => {
    const navigate = useNavigate();
    const { hasAccess } = useAccessControl();
    const [accessStatus, setAccessStatus] = useState<AccessStatus | undefined>(
      AccessStatus.LOADING
    );

    useEffect(() => {
      const isAccessGranted = hasAccess(access);
      
      if (typeof isAccessGranted === 'boolean') {
        setAccessStatus(
          isAccessGranted ? AccessStatus.GRANTED : AccessStatus.REJECTED
        );
      }
    }, [hasAccess]);

    if (accessStatus === AccessStatus.LOADING) {
      return (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress />
        </Stack>
      );
    }

    if (accessStatus === AccessStatus.REJECTED) {
      return (
        <Stack spacing={3} justifyContent="center" alignItems="center">
          <Avatar sx={{ bgcolor: grey[100], padding: 8 }}>
            <HugeiconsIcon icon={LockIcon} size={70} color={grey[500]} />
          </Avatar>
          <Stack>
            <Typography variant="h2">Acceso Restringido</Typography>
            <Typography variant="body1">
              No tienes permiso para ver esto
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            startIcon={<HugeiconsIcon icon={ArrowLeft01Icon} />}
            onClick={() => navigate(-1)}
          >
            Regresar
          </Button>
        </Stack>
      );
    }

    if (accessStatus === AccessStatus.GRANTED) {
      return <WrappedComponent {...(props as P)} hasAccess={hasAccess} />;
    }

    return null;
  };

  return EnhancedComponent;
};

export default withAccessControl;
